module.exports = __webpack_public_path__ + "static/media/KN.7ba1c433.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/KN.svg
// module id = 2187
// module chunks = 7